// extracted by mini-css-extract-plugin
module.exports = {"navbar":"Navbar_navbar__x4v20","title":"Navbar_title__2ioHP","icon":"Navbar_icon__zbK3A","username":"Navbar_username__29dVX"};